<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">
    <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
        <p style="color: black"> กำลังโหลดข้อมูล... </p>
    </ngx-spinner>
    <div class="col-lg-12 no-print">
        <div class="card">
            <div class="card-header">
                <h1>พิมพ์ใบปะหน้าคำขอสินเชื่อปี 65/66 โซน {{zone}}</h1>
            </div>
            <div class="card-body">
                <mat-form-field appearance="standard">
                    <mat-label>ค้นหาในตาราง</mat-label>
                    <input matInput (keyup)="Filterby($event)" placeholder="ชื่อ เลขที่คำขอ" #input>
                    </mat-form-field>

                    <div class="mat-elevatiom-z8">
                        <table mat-table [dataSource]="allpromisebyzone" matSort matSortStart="desc" style="width: 100%;">

                            <ng-container matColumnDef="number">
                               <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> เลขคำขอ </th>
                               <td mat-cell *matCellDef="let element;"> {{element.docid}} </td>  
                            </ng-container>
        
                            <ng-container matColumnDef="datetime">
                               <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> วันเวลา </th>
                               <td mat-cell *matCellDef="let element;">  {{element.datepost_th}} </td>
                             </ng-container>
                          
                            <ng-container matColumnDef="plat_no">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> หมายเลขแปลง </th>
                              <td mat-cell *matCellDef="let element"> {{element.intlandno}} </td>
                            </ng-container>
                            
                            <ng-container matColumnDef="farmername">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> ชื่อ - สกุล </th>
                              <td mat-cell *matCellDef="let element"> {{element.fmname}}  </td>
                            </ng-container>
                        
                            <ng-container matColumnDef="mngcomment" >
                               <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit">ความเห็นผู้จัดการโซน </th>
                               <td mat-cell *matCellDef="let element"> {{element.nowpromise}} </td>
                            </ng-container>
        
                          
        
                            <ng-container matColumnDef="financialamount">
                               <th mat-header-cell *matHeaderCellDef mat-sort-header  id="Kanit"> วงเงิน </th>
                               <td mat-cell *matCellDef="let element"> {{element.money_amt.toLocaleString()}}  </td>
                             </ng-container>
                         
                             <ng-container matColumnDef="print" >
                                <th mat-header-cell *matHeaderCellDef mat-sort-header  id="Kanit"> <mat-icon>print</mat-icon> </th>
                                <td mat-cell *matCellDef="let element" > 
                                    <button class="btn  btn-primary btn-sm" (click)="print_doc(element.fmcode);"> <mat-icon>print</mat-icon> </button>
                                </td>
                             </ng-container>
                            
                             <ng-container matColumnDef="cancle" >
                                <th mat-header-cell *matHeaderCellDef mat-sort-header  id="Kanit"> <mat-icon>highlight_off</mat-icon> </th>
                                <td mat-cell *matCellDef="let element" > 
                                    <button class="btn  btn-danger btn-sm" (click)="cancledoc_id(element.docid)" *ngIf="element.doc_status==0"> 
                                        <mat-icon>highlight_off</mat-icon> 
                                    </button>
                                </td>
                             </ng-container>                                 
                                  
                            <tr mat-header-row class="bg-warning fw-bolder" *matHeaderRowDef="displayaskformoney ; sticky: true;" ></tr>
                            <tr mat-row *matRowDef="let row; columns: displayaskformoney;"></tr>
                            
                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                              <td class="mat-cell" colspan="4">ไม่มีข้อมูลตรงกัน "{{input.value}}"</td>
                            </tr>
                         </table>

                         <mat-paginator  [pageSizeOptions]="[1, 5, 10, 25, 50]" showFirstLastButtons aria-label="Select page of periodic elements"  
                         
                         ></mat-paginator>

                    </div>
                
            </div>
        </div>
    </div>

    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <img src="../../../../assets/images/logo-bsf.png" alt="BSF LOGO"> 
                 <div style="float:right;">
                    {{time}} 
                </div> 
                <div class="row">
                    <div class="col-12">
                        
                        <div style="float:left;">
                            <i class="far fa-newspaper"></i> แบบเสนอสินเชื่อออนไลน์ ปี 2565/2566
                        </div> 
                        <div style="float:right;">
                            Supcode : {{supcode}} <u> {{supname}} </u>
                        </div> 
                    </div>
                    
                </div>
                <div class="row">
                    <div class="col-12">
                        <div style="background-color: rgb(255, 255, 179);">
                             <p *ngFor="let item of datafamer"> <i class="far fa-user"></i> โควตา : {{item.fmcode_b1}} : {{item.fmname}} ที่อยู่ {{item.address}} โทร {{item.TEL}}</p>
                        </div>
                    </div>
                    
                </div>
                <div class="row">
                    <div class="col-12">
                        <table class="table table-sm">
                            <thead>
                                <tr class="table-success">
                                    <td>เลขที่คำขอ </td>
                                    <td>วันเวลา</td>
                                    <td>โซน</td>
                                    <td>หมายเลขแปลง</td>
                                    <td>ข้อมูลแปลง</td>
                                    <td>เหตุผลการขอ</td>
                                    <td>จำนวนเงิน</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of dataone; index as i">
                                    <td>{{item.docid}}</td>
                                    <td>{{DatetoLocal(item.datepost)}}</td>
                                    <td>{{item.zonePost}}</td>
                                    <td>{{item.intlandno}}</td>
                                    <td> อ้อย {{item.canename}} พท. {{item.landvalue}} ไร่ เป้าผลผลิต {{item.target_yield}} </td>
                                    <td>{{item.comment1}}</td>
                                    <td>{{item.money_amt.toLocaleString()}}</td>
                                </tr>
                                <tr class="table-success">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>*** รวม ***</td>
                                    <td> <U>{{summoney}}</U> </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                </div>

                <!-- ผลผลิต -->
                <div class="row">
                    <div class="col-12">
                        <table class="table table-sm">
                            <tbody class="text-bold" *ngFor="let item of retadata">
                                <tr>
                                    <td>ผลผลิตปี 60/61</td>
                                    <td> {{item.yield6061.toLocaleString()}} </td>
                                    <td>วงเงินปุ๋ยอนุมัติ</td>
                                    <td><u>{{item.manure_amount.toLocaleString()}}</u></td>
                                    <td>วงเงินส่งเสริมอนุมัติ</td>
                                    <td> <u>{{item.credit_amount.toLocaleString()}}</u>  </td>
                                    <td> วงเงินส่งเสริมยังไม่อนุมัติ  (P) </td>
                                    <td> <u> {{item.credit_amountP.toLocaleString()}}</u>  </td>
                                </tr>
                                <tr>
                                    <td>ผลผลิตปี 61/62</td>
                                    <td>{{item.yield6162.toLocaleString()}}</td>
                                    <td>วงเงินปุ๋ยใช้ไป</td>
                                    <td><u>{{item.puy6566.toLocaleString()}}</u></td>
                                    <td>วงเงินส่งเสริมที่ใช้ไป</td>
                                    <td> <u>{{item.btMoney6364.toLocaleString()}}</u>  </td>
                                    
                                </tr>
                                <tr>
                                    <td>ผลผลิตปี 62/63</td>
                                    <td>{{item.yield6263.toLocaleString()}}</td>
                                    <td>วงเงินปุ๋ยคงเหลือ</td>
                                    <td><u>{{item.manure_left.toLocaleString()}}</u></td>
                                    <td>วงเงินส่งเสริมที่คงเหลือ</td>
                                    <td> <u>{{item.credit_left.toLocaleString()}}</u>  </td>
                                   
                                </tr>
                                <tr>
                                    <td>ผลผลิตปี 63/64</td>
                                    <td>{{item.yield6364.toLocaleString()}}</td>
                                   <td>ประเมินอ้อย</td>
                                   <td> <u>{{item.sumassess.toLocaleString()}}</u>  </td>
                                    
                                </tr>
                                <tr>
                                    <td>ผลผลิตปี 64/65</td>
                                    <td>{{item.yield6465.toLocaleString()}}</td>
                                  
                                </tr>
    
                                <tr>
                                    <td>ผลผลิตปี 65/66</td>
                                    <td>.........................</td>
                                </tr>
                               
                            </tbody>
                        </table>
                    </div>
                   
                </div>
                <!-- ผลผลิต -->
                <!-- เงินประเมิน -->
                <div class="row"  *ngFor="let item of retadata">
                    <div class="col-12">
                        <p>
                            บาทต่อตัน (ประเมิน 65/66) ปุ๋ย,ยา <u>{{item.btFactor.toLocaleString()}}</u>  เงินส่งเสริมที่ใช่ไป <u> {{item.btMoney.toLocaleString()}}</u> รวมขอครั้งนี้ .................. รวม ...............
                        </p>
                       
                        <p>
                            ระยะยาว (ยอดหนี้ ..................).................... รวมทั้งสิ้น ...................
                        </p>
                        <p>
                            บาทต่อตัน (ผลผลิต 63/64) ปุ๋ย,ยา <u>{{item.btFactor6364.toLocaleString()}}</u>  เงินส่งเสริมที่ใช่ไป <u>{{item.btMoney6364.toLocaleString()}}</u>  รวมขอครั้งนี้ .................. รวม ...............
                        </p>
                        <p>
                            ระยะยาว (ยอดหนี้ ..................).................... รวมทั้งสิ้น ...................
                        </p>
                    </div>
                   
                   
                </div>
                <!-- เงินประเมิน -->

                <!-- ขอเบิก -->
                <div class="row">
                    <div class="col-12">
                        <table class="table table-sm">
                            <tbody>
                                <tr>
                                    <td>ขอเบิกเงินส่งเสริม สำหรับปีการผลิตอ้อย 65/66</td>
                                    <td>.........................  บาท วงเงิน (  ) ปกติ  (  ) เกินวงเงิน</td>
                                </tr>
                                <tr>
                                    <td>ขอเบิกเงินส่งเสริม สินเชื่อระยะยาว</td>
                                    <td>.........................  บาท ผ่อนชำระ</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td> (  )  2 ปี  (  ) 3 ปี (  ) 4 ปี  (  ) 5 ปี (  ) 6 ปี</td>
                                </tr>
                                <tr>
                                    <td>ขอเบิกเงินส่งเสริมค่าซ่อมรถ ชำระปี 65/66</td>
                                    <td>.........................  บาท วงเงิน (  ) ปกติ  (  ) เกินวงเงิน</td>
                                </tr>
                                <tr>
                                    <td>ขอเบิกเงินส่งเสริมค่าตัด ชำระปี 65/66</td>
                                    <td>.........................  บาท วงเงิน (  ) ปกติ  (  ) เกินวงเงิน</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="text-bold">( &nbsp; &nbsp; &nbsp; &nbsp;) &nbsp;ชาวไร่ปรับโครงสร้างหนี้  
                                        &nbsp;( &nbsp; &nbsp; &nbsp; &nbsp;) &nbsp;หมดหนี้  &nbsp;( &nbsp; &nbsp; &nbsp; &nbsp;) &nbsp;ไม่หมดหนี้</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                   
                </div>
                  <!-- ขอเบิก -->

                <!-- More Comemnt -->
                <div class="row">
                    <div class="col-12">
                        <table class="table table-sm">
                   
                            <tbody>
                                <tr>
                                    <td colspan="4">  ความคิดเห็นเพิ่มเติม.......................................
                                    ........................................................................
                                    ........................................................................
                                    ..................................
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                    ........................................................................
                                    ........................................................................
                                    ........................................................................
                                    ..................................
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                    ........................................................................
                                    ........................................................................
                                    ........................................................................
                                    ..................................
                                    </td>
                                </tr>
                               
                            </tbody>
                        </table>
                    </div>
                   
                </div>
               <!-- More Comemnt -->
                
               <!-- Lisence -->
               <div class="row">
                   <div class="col-12">
                    <table class="table table-sm">
                        <tbody>
                            <tr>
                                <td></td>
                                <td> ลงชื่อ.....................................ชาวไร่ผู้กู้ </td>
                                <td></td>
                                <td> ลงชื่อ.....................................นักส่งเสริม</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>  ............./.........../..............</td>
                                <td></td>
                                <td> ............./.........../..............</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td> ลงชื่อ.....................................ผู้จัดการโซน </td>
                                <td></td>
                                <td> ลงชื่อ.....................................หัวหน้าส่วน</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>  ............./.........../..............</td>
                                <td></td>
                                <td> ............./.........../..............</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td> ลงชื่อ.....................................ผู้อำนวยการ </td>
                                <td></td>
                                <td> ลงชื่อ.....................................กรรมการจัดการ</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>  ............./.........../..............</td>
                                <td></td>
                                <td> ............./.........../..............</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                   </div>
                
               </div>
                 <!-- Lisence -->
             
    
               
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
